<template>
  <input
    class="chat-text-field py-2 px-3"
    v-bind="$attrs"
    :value="modelValue"
    @input="onInputMessage($event.target.value)"
    type="text"
    placeholder="Enter your message"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    modelValue: String
  },

  setup(props, { emit }) {
    function onInputMessage(value: string) {
      emit("update:modelValue", value);
    }

    return { onInputMessage };
  }
});
</script>

<style lang="scss" scoped>
.chat-text-field {
  outline: none;
  border: 1px solid $grey;
  border-radius: 0.9rem;
  font-size: 12pt;
}
</style>
